var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info_outline",
    clipPath: "url(#clip0_73_192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16666 5.83329H10.8333V7.49996H9.16666V5.83329ZM9.16666 9.16663H10.8333V14.1666H9.16666V9.16663ZM9.99999 1.66663C5.39999 1.66663 1.66666 5.39996 1.66666 9.99996C1.66666 14.6 5.39999 18.3333 9.99999 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99996C18.3333 5.39996 14.6 1.66663 9.99999 1.66663ZM9.99999 16.6666C6.32499 16.6666 3.33332 13.675 3.33332 9.99996C3.33332 6.32496 6.32499 3.33329 9.99999 3.33329C13.675 3.33329 16.6667 6.32496 16.6667 9.99996C16.6667 13.675 13.675 16.6666 9.99999 16.6666Z",
    fill: "#A7A9AC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsInfo);
export default __webpack_public_path__ + "static/media/WHSInfo.6194a0c759bd8ff5bc7501c8eea39bda.svg";
export { ForwardRef as ReactComponent };